import { createSvgIconComponent } from "../utils";

export const IconBasketball = createSvgIconComponent({
  path: "M6.949 8.34A12.26 12.26 0 014.7 15.113a8.166 8.166 0 006.599 0A12.259 12.259 0 019.051 8.34zm4.985-7.138a11.605 11.605 0 00-2.18 6.459H16a7.796 7.796 0 00-4.066-6.46M0 8.34a7.795 7.795 0 004.073 6.462 11.604 11.604 0 002.18-6.462zm4.066-7.138A7.794 7.794 0 000 7.661h6.245a11.602 11.602 0 00-2.18-6.459m4.986 6.459A12.265 12.265 0 0111.3.887a8.164 8.164 0 00-6.599 0A12.266 12.266 0 016.95 7.661zm2.874 7.142A7.794 7.794 0 0016 8.34H9.748a11.6 11.6 0 002.177 6.463",
  fill: "currentColor",
  viewBox: "0 0 16 16",
});
